import Axios from 'axios';
const axios = Axios.create({
    timeout: 30000
});
export const setBaseUrl = (url) => {
    axios.defaults.baseURL = url;
};
export const setTenantId = (id) => {
    axios.defaults.headers["TenantId"] = id;
};
export default axios;
